import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TConsultaEstoque } from "pages/estoque/ConsultaEstoque.service";
import { FichaImagemDetalheDTO, IProdutoRow } from "./../../pages/registra-venda/registra-venda.model";

export type FichaImagemAssociacao = {
    uuidProduto: string;
    imagens: FichaImagemDetalheDTO[];
};

type ImagemState = {
    imagens: FichaImagemAssociacao[];
};

const initialState: ImagemState = {
    imagens: [],
};

const imagemSlice = createSlice({
    name: "imagem",
    initialState,
    reducers: {
        addUuidsProdutoProdutoRow: (state, action: PayloadAction<IProdutoRow[]>) => {
            action.payload.forEach((e) => {
                const uuidProduto = e.produto.uuidProduto;

                const exists = state.imagens.some((i) => i.uuidProduto === uuidProduto);
                if (!exists) {
                    state.imagens.push({
                        uuidProduto,
                        imagens: [],
                    });
                }
            });
        },
        addUuidsProdutoEstoque: (state, action: PayloadAction<TConsultaEstoque[]>) => {
            action.payload.forEach((e) => {
                const uuidProduto = e.sku.uuidProduto;

                const exists = state.imagens.some((i) => i.uuidProduto === uuidProduto);
                if (!exists) {
                    state.imagens.push({
                        uuidProduto,
                        imagens: [],
                    });
                }
            });
        },

        addImagensUuidProduto: (state, action: PayloadAction<FichaImagemAssociacao[]>) => {
            action.payload.forEach(({ uuidProduto, imagens }) => {
                const found = state.imagens.find((e) => e.uuidProduto === uuidProduto);

                if (found) {
                    found.imagens = imagens;
                } else {
                    state.imagens.push({ uuidProduto, imagens });
                }
            });
        },
    },
});

export const {
    addUuidsProdutoProdutoRow,
    addUuidsProdutoEstoque,
    addImagensUuidProduto
} = imagemSlice.actions;
export const imagemReducer = imagemSlice.reducer;
